import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApiMembersEmployeeConditionSubmissionsIndexRequestType,
  ApiMembersEmployeeConditionSubmissionsIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApiMembersEmployeeConditionSubmissionsIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApiMembersEmployeeConditionSubmissionsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiMembersEmployeeConditionSubmissionsIndexResponseType>(
      "/api/members/employee_condition_submissions",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApiMembersEmployeeConditionSubmissionsIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApiMembersEmployeeConditionSubmissionsIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiMembersEmployeeConditionSubmissionsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["apiMembersEmployeeConditionSubmissionsIndex", params],
    ({ pageParam }) => {
      return request({
        params,
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
